import { Tooltip, IconButton as MuiIconButton, IconButtonProps } from '@mui/material';

type Props = IconButtonProps & {
  title?: string;
  icon?: React.ReactNode;
};

const IconButton = (props: Props) => {
  const { title, icon, ...iconButtonProps } = props;
  return (
    <Tooltip title={title}>
      <MuiIconButton aria-label="view-order-in-case" sx={{ border: '1px solid' }} {...iconButtonProps}>
        {icon}
      </MuiIconButton>
    </Tooltip>
  );
};

export default IconButton;
